import React from 'react';

function SignUp() {
  return (
    <div>
        <section className="categories section bg-grey">
            <div className="container">
                
                <div className="loginwrap">
                    <div className="row g-0">
                      <div className="d-none d-md-flex col-md-4 col-lg-5 bg-image">
                          <div><h3 className="text-white">welcome</h3>
                            <h6 className="pb-3 text-white text-center">why sign up?</h6>
                            <p className="text-left text-white">lorem ipsum is simply dummy text of the printing
                              and typesetting industry. lorem ipsum has been
                              the industry's standard dummy text ever since the
                              1500s, </p></div>
                      </div>
                      <div className="col-md-8 col-lg-7 rightbx">
                        <div className="login d-flex align-items-center py-5">
                          <div className="container">
                            <div className="row">
                              <div className="col-md-11 col-lg-10 mx-auto">
                                    <h5 className="text-center">create your admissify account</h5>
                                </div>
                                <div className="col-md-9 col-lg-8 mx-auto">
                                    <h6 className="text-center">use mobile number for registration </h6>
                                    <div className="fields-wrp">
                                        <form action="#">
                                          <div className="field">
                                            <input type="text" required/>
                                            <label>name</label>
                                            <span className="fa fa-user p-2"></span>
                                          </div>
                                          <div className="field">
                                            <input type="text" required/>
                                            <label>mobile number</label>
                                            <span className="fa fa-phone p-2"></span>
                                          </div>
                                          <div className="field">
                                            <input type="text" required/>
                                            <label>email</label>
                                            <span className="fa fa-envelope p-2"></span>
                                          </div>
                                          <div className="signup-link">already a member? <a href="#">login here</a></div>
                                         
                                          <div className="fieldbtn">
                                            <input type="submit" data-toggle="modal" data-target="#loginwithotp" className="bggreadent" value="get otp"/>
                                          </div>
                                          
                                        </form>
                                      </div>
                                  




                                
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                
            </div>

        </section>
    </div>
  );
}

export default SignUp;
